import { getCookieValue } from "./cookies";
import getSessionData from "./getSessionData";

export const logger = (message, { level = "info", customAttributes = {} }) => {
  const visitorId = getCookieValue("ww_browser_id");
  const { uuid } = getSessionData();

  const mergedCustomAttributes = {
    ...customAttributes,
    userAgent: navigator?.userAgent,
    ww_browser_id: visitorId,
    uuid
  };

  if (mergedCustomAttributes?.error?.config) {
    delete mergedCustomAttributes.error.config;
  }

  if (level === "error") {
    console.error(message, mergedCustomAttributes);
  }

  if (typeof window?.newrelic?.log !== "function") {
    return;
  }

  window?.newrelic?.log(message, {
    level,
    customAttributes: mergedCustomAttributes
  });
};
